import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import StationeryPurchaseOrderNewEditForm from '../stationery-purchase-order-new-edit-form';

export default function StationeryPurchaseOrderCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading="Create a new purchase order"
        links={[
          {
            name: 'Purchase Orders',
            href: paths.dashboard.stationeryPurchaseOrder.root,
          },
          { name: 'Create a new purchase order' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <StationeryPurchaseOrderNewEditForm />
    </Container>
  );
}
